export const getPhoneNumberPart = (
  phoneNumber: string | null | undefined,
  part: number
) => {
  if (!phoneNumber) {
    return ''
  }

  const splited = phoneNumber.split('-')

  return splited.length >= part ? splited[part - 1] : ''
}

const cleansingPhoneNumber = (phoneNumber: string): string => {
  // if (phoneNumber.substr(0, 1) === '-') {
  //   return cleansingPhoneNumber(phoneNumber.substr(1))
  // }

  // if (phoneNumber.substr(-1) === '-') {
  //   return cleansingPhoneNumber(phoneNumber.substr(0, phoneNumber.length - 1))
  // }

  if (phoneNumber === '-') {
    return ''
  }

  return phoneNumber
}

export const createSettingPhoneNumber = (
  newValue: string,
  phoneNumber: string | null | undefined,
  part: number
) => {
  if (!phoneNumber) {
    return newValue
  } else {
    const splited = phoneNumber.split('-')

    if (splited.length >= part - 1) {
      splited[part - 1] = newValue.trim()
    }

    return cleansingPhoneNumber(splited.join('-'))
  }
}
